import { useLastFleetVehicleGaranties } from '@/hooks/api/use-accidents';
import { useSelectedContract } from '@/hooks/api/use-contracts';
import { getContractGarantiesOptions } from '@/lib/contracts';

/** Garantie lue par la déclaration (`code`, `code_famille`). */
export interface DeclarationGarantie {
    code?: unknown;
    code_famille?: unknown;
    [key: string]: unknown;
}

/**
 * Garanties prises en compte par la déclaration : celles du véhicule de flotte consulté pour un
 * contrat flotte, celles du contrat sinon.
 */
export const useDeclarationGaranties = (): DeclarationGarantie[] | undefined => {
    const contract = useSelectedContract();
    const isFleet = !!contract?.flotte;
    const fleetGaranties = useLastFleetVehicleGaranties(isFleet);

    return isFleet ? fleetGaranties : getContractGarantiesOptions(contract);
};
